import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Button, Form, Message, Segment, Divider
} from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import AuthActions from 'Redux/AuthRedux'
import DebugConfig from 'Config/DebugConfig'
import GoogleLogin from 'react-google-login'
import { BottomLink } from './AuthPartials'
import styles from './LoginStyles'

class LoginForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      email: DebugConfig.isDev ? 'atinder90.a@gmail.com' : '',
      password: DebugConfig.isDev ? 'changeme' : ''
    }
  }

  componentDidMount () {
    this.props.authReset()
  }

  componentDidUpdate (prevProps) {
    if (this.props.authData['access-token']) {
      this.props.history.replace('/')
    }
  }

  onLogin = () => {
    this.props.loginRequest(this.state.email, this.state.password)
  }

  onEmailChange = (_, { value }) => {
    this.setState({ email: value })
  }

  onPassChange = (_, { value }) => {
    this.setState({ password: value })
  }

  render () {
    return (
      <div className={styles.loginForm}>
        {this.props.error &&
          <Message color='red'>{this.props.error}</Message>
        }
        {this.props.authData && this.props.authData.message &&
          <Message color='yellow'>{this.props.authData.message}</Message>
        }
        <Form size='large'>
          <Segment stacked>
            <GoogleLogin
              clientId="669262296891-9sl0ol8qsmndbqvrg66qm5ubr8nhebqs.apps.googleusercontent.com"
              buttonText="Sign in with Google"
              onSuccess={this.props.googleLoginRequest}
              onFailure={() => {}}
              cookiePolicy={'single_host_origin'}
              scope='email profile'
              responseType='code'
            />
            <Divider
              className={styles.divider}
              horizontal>Or</Divider>
            <Form.Input
              fluid
              icon='user'
              iconPosition='left'
              placeholder='E-mail address'
              onChange={this.onEmailChange} />
            <Form.Input
              fluid
              icon='lock'
              iconPosition='left'
              placeholder='Password'
              type='password'
              onChange={this.onPassChange}
            />
            <Button
              primary
              fluid
              size='large'
              onClick={this.onLogin}
              loading={this.props.fetching}
              className={styles.loginBtn}>
                Sign In
            </Button>
            <Link
              to={'/auth/forgot'}>Forgot Password?</Link>
          </Segment>
        </Form>
        <BottomLink
          text="Don't have an account?"
          link={
            <Link to={'/auth/signup'}>Sign Up</Link>
          }
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  fetching: state.auth.fetching,
  error: state.auth.error
})

const mapDispatchToProps = (dispatch) => ({
  googleLoginRequest: (authData) =>
    dispatch(AuthActions.googleLoginRequest(authData)),
  loginRequest: (email, pass) =>
    dispatch(AuthActions.loginRequest(email, pass)),
  authReset: _ => dispatch(AuthActions.authReset())
})

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm)



// WEBPACK FOOTER //
// ./src/Pages/Auth/Login.js